<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/12M8jqr/tc-custom/9781460381151.jpg?1705766095329" alt="This image is the cover for the book Fortune for the Outlaw's Daughter"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Fortune for the Outlaw's Daughter
      </h1>
      <p class="bookDescription body article font2">
        <p>More precious than gold <br/><br/>Cole "Lucky" DuMont is off to forge his future in the Alaskan hills. Standing in his way? A dark-haired beauty in need of rescue. <br/><br/>Maddie Stockwell's life has always been ruled by men. And now, to ensure her freedom, she strikes a deal with her gorgeous savior: she'll help Lucky in his quest, and find her own fortune along the way! Except when Maddie has to pose as Lucky's wife, she feels a thrill she could never have anticipated. And suddenly there's something even more tempting than gold on her mind</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Lauri Robinson
      </h2>
      
      <p class="authorDescription body article">Lauri Robinson lives in Minnesota where she and her husband spend every spare moment with their three grown sons and their families&mdash;spoiling the grandchildren. She&rsquo;s a member of Romance Writers of America and Northern Lights Writers. Along with volunteering for several organizations, she is a diehard Elvis and NASCAR fan. Her favorite getaway location is along the Canadian Border of Northern Minnesota on the land homesteaded by her great-grandfather.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Harlequin
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?8317f1be